import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 120px;
  height: 100px;
  background-size: cover;
  background-position: center center;
  background-color: black;
  border-radius: 10px;
  margin: 10px 0;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.1);
  cursor: pointer;

  &:hover {
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.5);
    background-color: rgba(0, 0, 0, 0.5);
  }

  &.selected {
    border: 1px solid red;
  }
`;
